export const DROP_DOWN = {
    "fileSize": [
        { "value": 0, "valueText": "", "label": "Site upload limit (750MB)" },
        { "value": 786432000, "valueText": "750MB", "label": "750MB" },
        { "value": 524288000, "valueText": "500MB", "label": "500MB" },
        { "value": 262144000, "valueText": "250MB", "label": "250MB" },
        { "value": 104857600, "valueText": "100MB", "label": "100MB" },
        { "value": 52428800, "valueText": "50MB", "label": "50MB" },
        { "value": 20971520, "valueText": "20MB", "label": "20MB" },
        { "value": 10485760, "valueText": "10MB", "label": "10MB" },
        { "value": 5242880, "valueText": "5MB", "label": "5MB" },
        { "value": 2097152, "valueText": "2MB", "label": "2MB" },
        { "value": 1048576, "valueText": "1MB", "label": "1MB" },
        { "value": 512000, "valueText": "500KB", "label": "500KB" },
        { "value": 102400, "valueText": "100KB", "label": "100KB" },
        { "value": 51200, "valueText": "50KB", "label": "50KB" },
        { "value": 10240, "valueText": "10KB", "label": "10KB" }
    ],
}